import { GlIcon } from '@gitlab/ui';
import { numberToHumanSize } from '~/lib/utils/number_utils';
export default {
    name: 'DownloadViewer',
    components: {
        GlIcon
    },
    props: {
        path: {
            type: String,
            required: true
        },
        filePath: {
            type: String,
            required: false,
            default: ''
        },
        fileSize: {
            type: Number,
            required: false,
            default: 0
        }
    },
    computed: {
        fileSizeReadable () {
            return numberToHumanSize(this.fileSize);
        },
        fileName () {
            // path could be a base64 uri too, so check if filePath was passed additionally
            return (this.filePath || this.path).split('/').pop();
        }
    }
};
